import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import './styles/tokens.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles.css';
import App from './App';

// Initialize Sentry only when DSN is configured (production)
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || 'development',
    tracesSampleRate: 0.1,
    // Don't send errors if user hasn't accepted analytics cookies
    beforeSend(event) {
      try {
        const consent = JSON.parse(localStorage.getItem('cardlockr_cookie_consent') || 'null');
        if (!consent) return null; // Banner not yet answered — don't send
      } catch {
        return null;
      }
      return event;
    },
  });
}

// Initialize PostHog only when key is configured and user has accepted analytics cookies
if (process.env.REACT_APP_POSTHOG_KEY) {
  try {
    const consent = JSON.parse(localStorage.getItem('cardlockr_cookie_consent') || 'null');
    if (consent?.analytics) {
      posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
        api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
        autocapture: true,
        capture_pageview: false, // Handled manually via PageViewTracker in App.js
        persistence: 'localStorage',
      });
    }
  } catch {
    // Ignore consent parse errors
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
